import { Toaster } from 'sonner'

const CustomToaster = () => {
    return <Toaster richColors position='top-center' />
}

export default CustomToaster
